export default __webpack_public_path__ + "static/media/o8.64290c01.jpg";